export const COLORS = {
 'theme':'#3b6499'
};